<template>
	<section id="create-object">
		<Notification corner="bottom-right" :closed="true" />
		<p>{{log('Teste pagina create')}}</p>
		<p>{{log('Teste pagina create')}}</p>
		<form @submit.prevent>
			<container textButton="voltar"
				:pathName="{ name: 'objetoList' }"
				:pathIcone="true">
				<load-content v-if="!isLoaded" />

				<div v-else>
					<div v-if="!$route.meta.readOnly" class="errors">
						<div v-if="submitted && $v.form.titulo.$error">
							<p v-if="!$v.form.titulo.required">O título é obrigatório</p>
						</div>

						<div v-if="submitted && $v.curador.$error">
							<p v-if="!$v.curador.required">O nome do curador é obrigatório</p>
						</div>

						<div v-if="submitted && $v.pedProducao.$error">
							<p v-if="!$v.pedProducao.required">O período de produção é obrigatório</p>
						</div>

						<div v-if="submitted && $v.disciplina.$error">
							<p v-if="!$v.disciplina.required">A disciplina é obrigatório</p>
						</div>

						<div v-if="submitted && $v.codDisc.$error">
							<p v-if="!$v.codDisc.required">A CodDisc é obrigatório</p>
						</div>

						<div v-if="submitted && $v.ordemTema.$error">
							<p v-if="!$v.ordemTema.required">A Ordem do tema é obrigatório</p>
						</div>

						<div v-if="submitted && $v.linhaProducao.$error">
							<p v-if="!$v.linhaProducao.required">A Linha producao é obrigatório</p>
						</div>

						<div v-if="submitted && $v.tipo.$error">
							<p v-if="!$v.tipo.required">O tipo é obrigatório</p>
						</div>

						<div v-if="submitted && $v.curadoria.$error">
							<p v-if="!$v.curadoria.required">A curadoria é obrigatória</p>
						</div>

						<div v-if="submitted && $v.subCuradoria.$error">
							<p v-if="!$v.subCuradoria.required">A sub-curadoria é obrigatória</p>
						</div>

						<div v-if="submitted && $v.eixo.$error">
							<p v-if="!$v.eixo.required">O eixo é obrigatório</p>
						</div>

						<div v-if="submitted && $v.form.descricao.$error">
							<p v-if="!$v.form.descricao.required">A descrição é obrigatória</p>
						</div>

						<!-- <div v-if="submitted && $v.form.urlObjeto.$error">
							<p v-if="!$v.form.urlObjeto.required">O link do objeto é obrigatório</p>
						</div> -->

						<div v-for="(item, index) in notValidProps" :key="index">
							<p >A propriedade {{item.nome}} é obrigatória</p>
						</div>

					</div>

					<div v-if="$route.params.id" id="container-datas-obj">
						<div id="criacao">
							<label>Criado em: </label>
							<span>{{form.datas.formatadas.criacao}}</span>
						</div>
						<div id="edicao">
							<label>Última atualização: </label>
							<span>{{form.datas.formatadas.edicao}}</span>
						</div>
					</div>

					<div v-if="$route.params.id" id="container-id-codigo-obj">

						<div id="id-obj">
							<div class="label">
								<div class="copy-id-obj">
									<span class="title">ID:</span>
									<copiar :text="$route.params.id" margin="none"></copiar>
								</div>
							</div>
						</div>

						<div id="codigo-obj">
							<div class="label">
								<span class="code-error" v-if="form.code.error">{{ form.code.msg }}</span>
								<div v-else class="copy-id-obj">
									<span class="title">Código:</span>
									<copiar :text="form.code" margin="none"></copiar>
								</div>
							</div>
						</div>

					</div>

					<div class="form-container">

						<div :class="[submitted && $v.tipo.$error && 'is-invalid', 'item tipo']">
							<v-select
								class="v-select-form"
								placeholder="Selecione o tipo"
								v-model="tipo"
								label="nome"
								:options="tipos"
								:disabled="isDisabled || $route.meta.readOnly"
								:clearable="false"
								@input="selectTipo">
								<template #no-options="{}">
									Nenhum tipo encontrado
								</template>
							</v-select>
						</div>

						<div class="item productionStatus">
							<v-select
								class="v-select-form"
								placeholder="Selecione o status"
								v-model="form.status"
								label="nome"
								:options="statusObjeto"
								:disabled="$route.meta.readOnly"
								:clearable="false"
							/>
						</div>

						<div class="item status">
							<check-status :checked="form.flagAtivo" @change="checkStatusChange" :disabled="$route.meta.readOnly"/>
						</div>

						<div :class="[submitted && $v.curadoria.$error && 'is-invalid', 'item curadoria']">
							<v-select
								class="v-select-form"
								placeholder="Selecione a Curadoria"
								v-model="curadoria"
								label="nome"
								:options="curadorias"
								:disabled="LOCK_CURADORIA || $route.meta.readOnly"
								:clearable="false"
								@input="selectCuradoria">
								<template #no-options="{}">
									Nenhuma curadoria encontrada
								</template>
							</v-select>
						</div>

						<div :class="[submitted && $v.subCuradoria.$error && 'is-invalid', 'item subcuradoria']">
							<v-select
								class="v-select-form"
								placeholder="Selecione a sub-curadoria"
								v-model="subCuradoria"
								label="nome"
								:options="subcuradorias"
								:disabled="LOCK_SUBCURADORIA || $route.meta.readOnly"
								:clearable="false"
								@input="selectSubCuradoria">
								<template #no-options="{}">
									Nenhuma sub-curadoria encontrada
								</template>
							</v-select>
						</div>

						<div :class="[submitted && $v.eixo.$error && 'is-invalid', 'item eixos']">
							<v-select
								class="v-select-form"
								placeholder="Selecione o eixo"
								v-model="eixo"
								label="nome"
								:options="eixos"
								:disabled="isDisabled || $route.meta.readOnly"
								:clearable="false"
								@input="selectEixo">
								<template #no-options="{}">
									Nenhum eixo encontrado
								</template>
							</v-select>
						</div>

						<div :class="[submitted && $v.form.titulo.$error && 'is-invalid', 'item titulo']">
							<input type="text" name="titulo" id="titulo" autocomplete="off" placeholder="Digite o título" v-model.lazy="form.titulo"  maxlength="150" :readonly="$route.meta.readOnly" />
						</div>

						<div :class="[submitted && $v.form.descricao.$error && 'is-invalid', 'item descricao']">
							<textarea name="" id="" cols="30" rows="5" placeholder="Descrição do objeto" v-model.lazy="form.descricao" :readonly="$route.meta.readOnly"/>
						</div>

						<propriedades-objeto :propriedades="this.properties" :disabled="$route.meta.readOnly" :separador="SEPARADOR_PROPS"></propriedades-objeto>

						<div :class="[submitted && $v.form.curador.$error && 'is-invalid', 'item curador']">
							<!--- <input type="text" name="curador" id="curador" autocomplete="off"
							placeholder="Nome do Curador <email@ensineme.com.br>" v-model.lazy="form.curador"  maxlength="800"
							:readonly="$route.meta.readOnly" />	-->
						<v-select
								class="v-select-form"
								placeholder="Selecione o curador"
								v-model="curador"
								label="nome"
								:options="nomesCuradores"
								:disabled="isDisabled || $route.meta.readOnly"
								v-model.lazy="form.curador">
								<template #no-options="{}">
									Nenhum perído de produção encontrado
								</template>
							</v-select>
								<!--- <select v-model="nomesCuradores">
								<option disabled value="">Escolha um curador</option>
								<option v-for="(item, key) in nomesCuradores" :key="key.name" :value="item.name">{{ item.nome}}</option>
							</select>-->

						</div>

						<div :class="[submitted && $v.form.pedProducao.$error && 'is-invalid', 'item pedProducao']">
							<v-select
								class="v-select-form"
								placeholder="Selecione período de produção"
								v-model="pedProducao"
								label="nome"
								:options="pedProducoes"
								:disabled="isDisabled || $route.meta.readOnly"
								v-model.lazy="form.pedProducao">
								<template #no-options="{}">
									Nenhum perído de produção encontrado
								</template>
							</v-select>
						</div>

						<div :class="[submitted && $v.form.disciplina.$error && 'is-invalid', 'item disciplina']">
							<input type="text" name="disciplina" id="disciplina" autocomplete="off"
							placeholder="Digite a disciplina" v-model.lazy="form.disciplina"  maxlength="300"
							:readonly="$route.meta.readOnly" />
						</div>

						<div :class="[submitted && $v.form.codDisc.$error && 'is-invalid', 'item codDisc']">
							<input type="text" name="codDisc" id="codDisc" autocomplete="off"
							placeholder="Digite o COD_DISC" v-model.lazy="form.codDisc"  maxlength="300"
							:readonly="$route.meta.readOnly" />
						</div>

						<div :class="[submitted && $v.form.ordemTema.$error && 'is-invalid', 'item ordemTema']">
							<v-select
								class="v-select-form"
								placeholder="Selecione a ordem dos temas"
								v-model="ordemTema"
								label="nome"
								:options="ordemTemas"
								:disabled="isDisabled || $route.meta.readOnly"
								:clearable="false"
								v-model.lazy="form.ordemTema">
								<template #no-options="{}">
									Nenhuma ordem encontrada
								</template>
							</v-select>
						</div>

						<div id="add-cursos-recorrentes" class="adds-container">
							<div class="titulo-add">
								<div class="search">
									<input type="text" v-model="tagTempText[CURSOS_RECORRENTES]"
									placeholder="Adicione cursos recorrentes" maxlength="200" :readonly="$route.meta.readOnly"
									@keyup.enter="addByEnter('btnCursos')"
									@keyup="(e) => onChangeTagPlus(e, { array: cursosRecorrentes }, CURSOS_RECORRENTES)"
									@focus="(e) => onChangeTagPlus(e, { array: cursosRecorrentes }, CURSOS_RECORRENTES)"
									@blur.capture="(e) => ocultaSugestaoTag(e, { ref: cursosRecorrentes })"/>
									<div class="btn-add">
										<button type="button" ref="btnCursos" class="button" @click="addTag({tag: tagTemp.id ? tagTemp : tagTempText[CURSOS_RECORRENTES], arrayRef: form.cursosRecorrentes, tipo: 3})" :disabled="tagTempText[CURSOS_RECORRENTES] < 2">Adicionar</button>
									</div>
								</div>
								<div class="list">
									<ul v-if="cursosRecorrentes.length > 0">
										<li v-for="tag in cursosRecorrentes" :key="tag.id"
											@click="() => selectTagsPlus(tag[0], {array: cursosRecorrentes})"><span>{{tag[0]?tag[0].nome:''}}</span></li>
									</ul>
								</div>
							</div>
							<div class="itens-add">
								<div v-for="(item, index) in form.cursosRecorrentes" :key="index" class="added-item">
									<span>{{item.nome}}</span>
									<button type="button" @click="removeAddedItem({index, arrayRef: form.cursosRecorrentes})" :disabled="$route.meta.readOnly"><i class="far fa-times-circle" /></button>
								</div>
							</div>
						</div>

						<div id="add-disciplinas-recorrentes" class="adds-container">
							<div class="titulo-add">
								<div class="search">
									<input type="text" v-model="tagTempText[DISCIPLINA_RECORRENTES]"
									placeholder="Adicione disciplinas recorrentes" maxlength="200" :readonly="$route.meta.readOnly"
									@keyup.enter="addByEnter('btnDisciplinas')"
									@keyup="(e) => onChangeTagPlus(e, { array: disciplinasRecorrentes }, DISCIPLINA_RECORRENTES)"
									@focus="(e) => onChangeTagPlus(e, { array: disciplinasRecorrentes }, DISCIPLINA_RECORRENTES)"
									@blur.capture="(e) => ocultaSugestaoTag(e, { ref: disciplinasRecorrentes })"
									/>
									<div class="btn-add">
										<button type="button" ref="btnDisciplinas" class="button" @click="addTag({tag: tagTemp.id ? tagTemp : tagTempText[DISCIPLINA_RECORRENTES], arrayRef: form.disciplinasRecorrentes, tipo: 2})" :disabled="tagTempText[DISCIPLINA_RECORRENTES] < 2">Adicionar</button>
									</div>
								</div>
								<div class="list">
									<ul v-if="disciplinasRecorrentes.length > 0">
										<li v-for="tag in disciplinasRecorrentes" :key="tag.id"
											@click="() => selectTagsPlus(tag[0], {array: disciplinasRecorrentes})"><span>{{tag[0]?tag[0].nome:''}}</span></li>
									</ul>
								</div>
							</div>
							<div class="itens-add">
								<div v-for="(item, index) in form.disciplinasRecorrentes" :key="index" class="added-item">
									<span>{{item.nome}}</span>
									<button type="button" @click="removeAddedItem({index, arrayRef: form.disciplinasRecorrentes})" :disabled="$route.meta.readOnly"><i class="far fa-times-circle" /></button>
								</div>
							</div>
						</div>
						<div id="add-tags-gerais" class="adds-container">
							<div class="titulo-add">
								<div class="search">
									<input type="text" v-model="tagTempText[TAGS_GERAIS]"
									placeholder="Adicione tags gerais" maxlength="200" :readonly="$route.meta.readOnly"
									@keyup.enter="addByEnter('btnGerais')"
									@keyup="(e) => onChangeTagPlus(e, { array: tagsGerais }, TAGS_GERAIS)"
									@focus="(e) => onChangeTagPlus(e, { array: tagsGerais }, TAGS_GERAIS)"
									@blur.capture="(e) => ocultaSugestaoTag(e, { ref: tagsGerais })"
									/>
									<div class="btn-add">
										<button type="button" ref="btnGerais" class="button" @click="addTag({tag: tagTemp.id ? tagTemp : tagTempText[TAGS_GERAIS], arrayRef: form.tagsGerais, tipo: TAGS_GERAIS})" :disabled="tagTempText[TAGS_GERAIS] < 2">Adicionar</button>
									</div>
								</div>
								<div class="list">
									<ul v-if="tagsGerais.length > 0">
										<li v-for="tag in tagsGerais" :key="tag.id"
											@click="() => selectTagsPlus(tag[0], {array: tagsGerais})"><span>{{tag[0]?tag[0].nome:''}}</span></li>
									</ul>
								</div>
							</div>
							<div class="itens-add">
								<div v-for="(item, index) in form.tagsGerais" :key="index" class="added-item">
									<span>{{item.nome}}</span>
									<button type="button" @click="removeAddedItem({index, arrayRef: form.tagsGerais})" :disabled="$route.meta.readOnly"><i class="far fa-times-circle" /></button>
								</div>
							</div>
						</div>

						<div id="add-autores" class="adds-container">
							<div class="titulo-add">
								<div class="search">
									<input type="text" v-model="autorTemp"
									@keyup.enter="addByEnter('btnAutor')"
									placeholder="Digite o nome do autor" maxlength="200" :readonly="$route.meta.readOnly"/>
									<div class="btn-add">
										<button type="button" ref="btnAutor" class="button" @click="addAutor" :disabled="autorTemp.length < 2">Adicionar</button>
									</div>
								</div>
							</div>
							<div class="itens-add">
								<div v-for="(autor, index) in form.autores" :key="index" class="added-item">
									<span>{{autor}}</span>
									<button type="button" @click="removeAddedItem({index, arrayRef: form.autores})" :disabled="$route.meta.readOnly"><i class="far fa-times-circle" /></button>
								</div>
							</div>
						</div>

						<div id="questoes-container">
							<div :class="{questoes:true, disabled:this.form.questoes.length == 0}">
									<div class="titulo">
										Questões: <span class='aviso' v-if="this.form.questoes.length == 0"> Não existem questões cadastradas para esse objeto.</span>
									</div>
									<div class="botoes" v-if="this.form.questoes.length > 0">
										<router-link
											:to="$route.meta.readOnly
												? `../questoes/${this.$route.params.id}`
												: `questoes/${this.$route.params.id}`">
											<button type="button" class="button visualizar">Visualizar</button>
										</router-link>

										<button @click="questionReport" type="button" class="button exportar">Exportar</button>
									</div>
							</div>

							<div id="tipo-questao-container">
								<div v-if="objectTypes.length">
									<exibe-tipo-questoes v-for="(type, index) in objectTypes" :key="`${type.tipoQuestaoId}-${index}`"
										:name="`${type.descricao} - (Objeto)`"
										:qtdDefault="type.qtd"
										:label="type.tipoQuestaoId"
										:prefix="`${type.tipoQuestaoId}-${index}`"
										:type="type.type"
										:dirty="type.dirty"
										:disabled="$route.meta.readOnly">
									</exibe-tipo-questoes>
								</div>

								<div v-if="computedCurationTypes.length">
									<exibe-tipo-questoes v-for="(type, index) in computedCurationTypes" :key="`${type.tipoQuestaoId}-${index}`"
										:name="`${type.descricao} - (Curadoria)`"
										:qtdDefault="type.qtd"
										:label="type.tipoQuestaoId"
										:prefix="`${type.tipoQuestaoId}`"
										:type="type.type"
										:dirty="type.dirty"
										:disabled="$route.meta.readOnly">
									</exibe-tipo-questoes>
								</div>

								<div v-if="dbFiltered.length" :key="dbFiltered.length">
									<exibe-tipo-questoes v-for="(type, index) in dbFiltered" :key="`${type.tipoQuestaoId}-${index}`"
										:name="`${type.descricao} - (Geral)`"
										:qtdDefault="type.qtd"
										:label="type.tipoQuestaoId"
										:prefix="`${type.tipoQuestaoId}`"
										:type="type.type"
										:dirty="type.dirty"
										:disabled="$route.meta.readOnly">
									</exibe-tipo-questoes>
								</div>
							</div>
						</div>

						<div id="pre-requisitos-container">
							<div class="requisitos-label">
								<i class="fas fa-exclamation-circle"></i>
								<span>Pré-requisito</span>
							</div>
							<div class="requisitos-input">
								<multiselect :options="objetos" :close-on-select="true" :clear-on-select="true" :searchable="true" :loading="isLoading" :hide-selected="true"
									placeholder="Pesquise por títulos de objetos" :showNoResults="true" :show-labels="false" label="titulo" track-by="titulo" @search-change="onChangeTitulo" @select="selectPreRequisito"
									:disabled="isDisabled || $route.meta.readOnly">
									<template slot="noResult">
										Nenhum objeto encontrado
									</template>

									<template slot="noOptions">
										Digite o título de um objeto
									</template>
								</multiselect>
							</div>

							<load-content v-if="loadingPrerequisito"/>

							<div id="pre-requisitos" class="requisitos-adicionados">
								<div v-if="form.preRequisito" class="requisito">
									<div class="tipo-requisito">
										<div><span>{{form.preRequisito.tipoNome}}</span></div>
									</div>
									<div class="nome-requisito">
										<span>{{form.preRequisito.titulo}}</span>
									</div>
									<div class="btn-remove-requisito">
										<button type="button" @click="() => form.preRequisito = ''"><i class="far fa-times-circle" /></button>
									</div>
								</div>
							</div>
						</div>

						<div id="link-objeto" :class="[submitted && $v.form.urlObjeto.$error && 'is-invalid']">
							<i class="fas fa-link"></i>
							<input v-model="form.urlObjeto" type="text" autocomplete="off" placeholder="Insira o link de acesso ao objeto" @blur="formataUrl" :readonly="$route.meta.readOnly"/>
							<toggle-button
								:width="70"
								:height="30"
								:color="`#01253f`"
								:sync="true"
								:value="https"
								:disabled="$route.meta.readOnly"
								:labels="{checked: 'HTTPS', unchecked: 'HTTP'}"
								@change="changeHttpStatus"/>

								<span @click="openLink" title="Acessar objeto" class="abrir_objeto fas fa-external-link-alt"></span>
						</div>

					</div>
				</div>
			</container>

			<div class="box-warning" v-if="form.status.status === 3 && !$route.meta.readOnly">
				<b>Atenção:</b> Objetos com o status "Preenchimento pendente" serão automaticamente alterados para o status "Pendente" ao realizar uma edição.
			</div>

			<div class="submit-form" v-if="isLoaded">
				<button-submit class="large" type="button" :onClick="save" :disabled="loadingSubmit || $route.meta.readOnly">
					SALVAR
				</button-submit>
			</div>
		</form>

		<div id="modal-code-change" class="modal-blackscreen" v-if="isModalCodeVisible" @close="() => this.isModalCodeVisible = !this.isModalCodeVisible">
			<div class="modal">
				<div type="text">
					Ao alterar esse campo o código do objeto também será alterado. Deseja continuar?
				</div>
				<div class="botoes">
					<button-submit type="button"  class="xs default">SIM</button-submit>
					<button-submit type="button"  class="xs blue">NÃO</button-submit>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import { ToggleButton } from 'vue-js-toggle-button'

import { tipos } from '@/services/tipos'
import { curadoria } from '@/services/curadoria'
import { objetos } from '@/services/objetos'
import { tags } from '@/services/tags'
import { questoes } from '@/services/questoes'
import { tipoQuestao } from '@/services/tipoQuestao'
import { atributos } from '@/services/propriedade'

import podeEditar from '@/mixins/podeEditarMixin'
import { getCode } from '@/helpers/objectCode'

import Container from '@/components/shared/Container'
import CheckStatus from '@/components/shared/Status'
import ButtonSubmit from '@/components/shared/ButtonAction'
import LoadContent from '@/components/shared/LoadContent'
import Copiar from '@/components/shared/Copiar'
import ExibeTipoQuestoes from './inc/ExibeTipoQuestoes'
import PropriedadesObjeto from './inc/PropriedadesObjeto'
import statusObjeto from '@/assets/enum/statusObjeto'

export default {
	name: 'createObjeto',
	components: { Container, ButtonSubmit, CheckStatus, LoadContent, ToggleButton, Copiar, ExibeTipoQuestoes, PropriedadesObjeto },
	mixins: [podeEditar],
	data () {
		return {

			pedProducoes: [],
			nomesCuradores: [],
			ordemTemas: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
			tagTemp: '',
			tagTempText: ['', '', '', ''],
			qtdQuestoes: [],
			tipoKey: 0,
			curadoriaKey: 0,
			form: {
				titulo: '',
				descricao: '',
				fonte: '',
				urlObjeto: '',
				tipo: '',
				preRequisito: '',
				periodoproducacao: '',
				curador: '',
				pedProducao: '',
				disciplina: '',
				codDisc: '',
				ordemTema: '',
				flagAtivo: true,
				autores: [],
				cursosRecorrentes: [],
				disciplinasRecorrentes: [],
				tagsGerais: [],
				questoes: [],
				status: { nome: 'Pendente', status: '2' }
			},
			tipos: [],
			curadorias: [],
			subcuradorias: [],
			eixos: [],
			autores: [],
			cursosRecorrentes: [],
			disciplinasRecorrentes: [],
			tagsGerais: [],
			textosModulos: [],
			objetos: [],
			preRequisitos: [],
			statusObjeto: statusObjeto.map(el => {
				if (el.filterOnly) {
					el.$isDisabled = true
				}

				return el
			}),
			autorTemp: '',
			propRefTemp: '',
			tipo: '',
			tag: '',
			curadoria: '',
			subCuradoria: '',
			eixo: '',
			fonte: '',
			textoModulo: '',
			usuario: '',
			novaTag: '',
			submitted: false,
			loadingSubmit: false,
			isDisabled: false,
			isLoading: false,
			isLoaded: false,
			isModalCodeVisible: false,
			callManageQuestions: false,
			loadingPrerequisito: false,
			SEPARADOR_PROPS: '##',
			PERFIL_ADM: 1,
			PERFIL_LIDER_CURADOR: 2,
			PERFIL_CURADOR: 3,
			TAGS_GERAIS: 1,
			DISCIPLINA_RECORRENTES: 2,
			CURSOS_RECORRENTES: 3,
			LOCK_CURADORIA: false,
			LOCK_SUBCURADORIA: false,
			https: true,
			curador: '',
			pedProducao: '',
			disciplina: '',
			codDisc: '',
			ordemTema: '',
			CuradoriaNormalizer (n) {
				const node = {
					id: n.id,
					label: n.nome
				}
				if ((n.subCuradoriasDeConhecimento) && (n.subCuradoriasDeConhecimento.length > 0)) {
					node.children = n.subCuradoriasDeConhecimento
				}
				return node
			}
		}
	},
	computed: {
		...mapGetters(['dbFiltered', 'notValidProps']),
		...mapState({
			objectTypes: state => state.typeQuestions.object,
			curationTypes: state => state.typeQuestions.curation,
			dbTypes: state => state.typeQuestions.db,
			properties: state => {
				return state.properties.list
			}
		}),
		computedCurationTypes: function () {
			return this.curationTypes.filter(c => !this.objectTypes.map(o => o.tipoQuestaoId).includes(c.tipoQuestaoId))
		},
		dirtys: function () {
			return [].concat(this.objectTypes, this.curationTypes, this.dbTypes)
				.filter(t => t.dirty)
				.filter((thing, index, self) => {
					return index === self.findIndex((t) => (
						t.tipoQuestaoId === thing.tipoQuestaoId
					))
				})
				.map(t => {
					return {
						objetoId: this.$route.params.id,
						tipoQuestaoId: t.tipoQuestaoId,
						qtd: t.qtd
					}
				})
		},
		perfis: function () {
			return this.$store.state.perfis
		}
	},
	validations () {
		return {
			form: {
				titulo: { required },
				descricao: { required },
				curador: { required },
				pedProducao: { required },
				disciplina: { required },
				codDisc: { required },
				ordemTema: { required }
			},
			tipo: { required },
			curadoria: { required },
			subCuradoria: { required },
			eixo: { required }
		}
	},
	async created () {
		window.removeEventListener('click', this.closeTagSuggestions)
		window.addEventListener('click', this.closeTagSuggestions)
		this.usuario = this.$auth.user()
		await this.curadoresNomes()
		await this.producoesPeriodo()
		const reqs = [tipos.findByActive(), curadoria.findByActiveInTree()]

		await Promise.all(reqs).then(data => {
			if (data[0]) {
				this.tipos = data[0].data
			} else {
				console.log('Erro ao buscar tipos ativos')
			}

			if (data[1]) {
				this.curadorias.push(...data[1].data)
			} else {
				console.log('Erro ao buscar curadorias em árvore')
			}
		})

		switch (this.usuario.perfil) {
		case this.PERFIL_LIDER_CURADOR:
		case this.PERFIL_CURADOR:
			this.LOCK_CURADORIA = true
			if (!this.$route.params.id) {
				/*
				* 1 - Caso o usuário seja ADM não é necessário popular a árvore de curadorias.
				* 2 - Caso seja uma edição de objetos a árvore será preenchida ao carregar os dados do mesmo
				*/
				this.populaArvoreCuradorias()
			}
			break
		default:
			break
		}

		// Recuperando os dados para edição
		if (this.$route.params.id) {
			this.isLoaded = false
			if (!this.objectTypes.length) await this.loadObjectTypesQuestions(this.$route.params.id) // coisa para pegar os tipos de questões :s

			const reqsEdit = [objetos.findById(this.$route.params.id), questoes.findById(this.$route.params.id)]

			Promise.all(reqsEdit).then(async reqsData => {
				if (reqsData[0]) {
					const data = reqsData[0].data

					if (this.usuario.perfil !== this.PERFIL_ADM && !this.podeEditar(data) && !(this.usuario.perfil === 6 && this.$route.meta.readOnly)) {
						return this.activeFlashMessage('Você não tem permissão para editar esse objeto.', () => this.$router.push({ name: 'objetoList' }), 'warning')
					}

					if (reqsData[1]) {
						data.questoes = reqsData[1].data
					} else {
						console.log('Erro ao buscar questões do objeto')
					}

					const cursosRecorrentes = []
					const tagsGerais = []
					const disciplinasRecorrentes = []
					let autores = []
					const tipo = { id: data.tipoId, nome: data.tipoNome, imagem: data.tipoImagem, icone: data.tipoIcone, codigo: data.tipoCodigo }

					const trataAutores = () => data.autores.includes('|') ? data.autores.split('|') : [data.autores]

					const trataTags = (strIds, strNomes) => {
						const arrayId = strIds.split('|')
						const arrayNome = strNomes.split('|')
						const tags = []
						arrayId.forEach((item, index) => {
							tags.push({ id: item, nome: arrayNome[index] })
						})
						return tags
					}
					const trataRequisito = async () => {
						await objetos.findById(data.idPreRequisito)
							.then(res => {
								const req = res.data
								if (req) this.form.preRequisito = { id: data.idPreRequisito, titulo: req.titulo, tipoId: req.tipoId, tipoNome: req.tipoNome }
							})
							.catch(err => {
								console.log(err)
							})
					}
					await this.selectTipo(tipo)
					if (data.autores) autores = trataAutores()
					if (data.cursosIds) cursosRecorrentes.push(...trataTags(data.cursosIds, data.cursosNomes))
					if (data.disciplinasIds) disciplinasRecorrentes.push(...trataTags(data.disciplinasIds, data.disciplinasNomes))
					if (data.tagsIds) tagsGerais.push(...trataTags(data.tagsIds, data.tagsNomes))

					// Recuperação das propriedades do tipo
					const allProps = await atributos.findByTipo(data.tipoId)
					if (allProps.data.length) {
						const props = {
							ids: [],
							nomes: [],
							multiplos: [],
							tiposEntrada: [],
							valoresDefault: [],
							obrigatorios: [],
							valores: [],
							tipo: data.tipoId
						}

						let prop = {}
						for (prop of allProps.data) {
							props.ids.push(prop.id)
							props.nomes.push(prop.nome)
							props.multiplos.push(prop.multiplo)
							props.tiposEntrada.push(prop.tipoEntrada)
							props.valoresDefault.push(prop.valorDefault)
							props.obrigatorios.push(prop.obrigatorio)

							if (data.propriedadesIds && data.propriedadesValores) {
								const i = data.propriedadesIds.split(this.SEPARADOR_PROPS).findIndex(el => el === prop.id)
								props.valores.push(data.propriedadesValores.split(this.SEPARADOR_PROPS)[i])
							}
						}

						this.setObjectProps(await this.sanatizedProps(props))
					}

					this.form = {
						code: getCode(data, true),
						titulo: data.titulo,
						descricao: data.descricao,
						fonte: data.fonte,
						urlObjeto: data.urlObjeto,
						preRequisito: data.idPreRequisito,
						flagAtivo: data.flagAtivo,
						autores: autores,
						cursosRecorrentes: cursosRecorrentes,
						disciplinasRecorrentes: disciplinasRecorrentes,
						tagsGerais: tagsGerais,
						temaCodigo: data.codigo,
						questoes: data.questoes,
						datas: {
							formatadas: {
								criacao: data.dtInsert,
								edicao: data.dtUpdate
							},
							criacao: data.dtInsertPadrao,
							edicao: data.dtIUpdatePadrao
						},
						codigo: data.codigo ? data.codigo.trim() : undefined,
						status: this.statusObjeto.find(el => el.nome.toUpperCase() === data.status),
						curador: data.curador,
						pedProducao: data.pedProducao,
						disciplina: data.disciplina,
						codDisc: data.codDisc,
						ordemTema: data.ordemTema
					}
					this.tipo = tipo

					// Popula categorias
					this.curadoria = this.curadorias.find(cur => {
						return cur.id === data.curadoriaId
					})

					this.selectCuradoria(this.curadoria)

					this.subCuradoria = this.curadoria.subCuradorias.find(cur => {
						return cur.id === data.subCuradoriaId
					})

					this.selectSubCuradoria(this.subCuradoria)

					if (data.eixoId) {
						this.eixo = this.subCuradoria.subCuradorias.find(sc => {
							return sc.id === data.eixoId
						})

						this.selectEixo(this.eixo)
					}

					// Controle http this.http
					if (data.urlObjeto) this.https = /https:\/\//.test(data.urlObjeto)

					if (data.idPreRequisito) trataRequisito()

					this.isLoaded = true
				} else {
					console.log('Erro ao obter objeto')
					// redirect to 404 page
					return this.$router.push({ name: 'cuardoriaList' })
				}
			})
		} else {
			this.isLoaded = true
		}
	},
	methods: {
		...mapActions(['loadObjectTypesQuestions', 'loadObjectTypesCuradoria', 'loadNewObjectProps', 'setObjectProps', 'unloadUnpersistedProps', 'formateProperties', 'sanatizedProps', 'unloadObjectProps']),
		closeTagSuggestions (evt) {
			const comp = evt.target.closest('.adds-container')
			if (!comp) {
				this.limparTags()
			}
		},
		log: function (e) {
			// console.log(e.currentTarget)
			// console.log(e)
		},
		openLink () {
			return this.form.urlObjeto ? window.open(this.form.urlObjeto) : false
		},
		async save () {
			// Realiza a alteração do status de "Preenchimento pendente" para "Pendente"
			if (this.form.status.status === 3) {
				this.form.status = statusObjeto.find(el => el.status === 2)
			}

			this.submitted = true
			this.loadingSubmit = true

			this.$v.$touch()
			if (this.notValidProps.length || this.$v.$invalid) {
				this.loadingSubmit = false
				window.scroll(0, 0)
				return
			}

			this.formSubmit = {
				...this.form,
				arvoreCuradoria: {
					curadoria: { id: this.curadoria.id, nome: this.curadoria.nome, codigo: this.curadoria.codigo },
					subCuradoria: { id: this.subCuradoria.id, nome: this.subCuradoria.nome },
					eixo: { id: this.eixo.id, nome: this.eixo.nome }
				},
				tipo: {
					id: this.tipo.id,
					codigo: this.tipo.codigo,
					nome: this.tipo.nome
				},
				preRequisito: this.form.preRequisito ? this.form.preRequisito.id : undefined,
				autores: this.form.autores.join('|'),
				tags: [].concat(this.form.cursosRecorrentes, this.form.disciplinasRecorrentes, this.form.tagsGerais),
				propriedades: await this.formateProperties(),
				status: this.form.status.status.toString()
			}

			delete this.formSubmit.cursosRecorrentes
			delete this.formSubmit.disciplinasRecorrentes
			delete this.formSubmit.tagsGerais

			if (this.$route.params.id) {
				if (!this.$route.meta.readOnly) {
					await objetos.update(this.$route.params.id, this.formSubmit)
						.then(async obj => {
							if (obj.status === 200) {
								await tipoQuestao.create(this.dirtys)
								return this.activeFlashMessage('Objeto alterado com sucesso!', () => this.$router.push({ name: 'objetoList' }), 'success')
							}
						})
						.catch((response) => {
							this.loadingSubmit = false
							this.catchMessage(response)
							window.scroll(0, 0)
						})
				}
			} else {
				if (!this.$route.meta.readOnly) {
					await objetos.create(this.formSubmit)
						.then(async obj => {
							if (obj.status === 200) {
								this.dirtys.forEach(d => { d.objetoId = obj.data.id })
								await tipoQuestao.create(this.dirtys)
								return this.activeFlashMessage('Objeto cadastrado com sucesso!', () => this.$router.push({ name: 'objetoList' }), 'success')
							}
						})
						.catch((response) => {
							this.loadingSubmit = false
							this.catchMessage(response)
							window.scroll(0, 0)
						})
				}
			}
		},
		checkStatusChange () {
			this.form.flagAtivo = !this.form.flagAtivo
			return this.form.flagAtivo
		},
		addTag (param) {
			if (param.tag.id) {
				this.notPushRepeatItem({ arrayRef: param.arrayRef, value: param.tag, prop: 'id' })
			} else {
				this.criaTag(param.tag, param.tipo, { array: param.arrayRef })
			}
			this.tagTempText[param.tipo] = ''
			this.$forceUpdate()
		},
		addAutor () {
			this.notPushRepeatItem({ arrayRef: this.form.autores, value: this.autorTemp })
			this.autorTemp = ''
		},
		removeAddedItem (param) {
			param.arrayRef.splice(param.index, 1)
		},
		activeFlashMessage (msg, callback = null, ftype = 'info') {
			window.notificationEM.open('', msg, ftype)
			setTimeout(() => {
				if (callback) {
					return callback()
				}
			}, 2000)
		},
		catchMessage (response) {
			window.notificationEM.open('', response.response.data.msg, 'error')
		},
		async selectTipo (param) { // TODO REFATORAR
			const original = this.tipo
			if (!this.$route.params.id) {
				this.tipo = param
				this.unloadObjectProps()
				this.mangeObjectCode()
				this.loadNewObjectProps(param.id)
			} else if (original) {
				this.$confirm('O Código do objeto será alterado. Deseja continuar?')
					.then(() => {
						this.tipo = param
						this.unloadUnpersistedProps()
						this.mangeObjectCode()
						this.loadNewObjectProps(param.id)
						this.tipoKey++
						this.activeFlashMessage('Código do objeto alterado!', () => {}, 'info')
					})
					.catch(() => {
						this.tipo = original || this.tipo
						this.tipoKey++
					})
			}
		},
		selectCuradoria (param) { // TODO REFATORAR
			const original = this.curadoria
			const originalId = this.curadoria.id

			if (!this.$route.params.id) {
				this.curadoria = param
				this.subcuradorias = param.subCuradorias
				this.subCuradoria = undefined
				this.eixo = undefined
				this.mangeObjectCode()
				this.manageCurationQuestionsTypes(param.id)
			} else if (originalId !== param.id) {
				this.$confirm('O Código do objeto será alterado. Deseja continuar?')
					.then(() => {
						this.curadoria = param
						this.subcuradorias = param.subCuradorias
						this.subCuradoria = undefined
						this.eixo = undefined
						this.mangeObjectCode()
						this.manageCurationQuestionsTypes(param.id)
						this.curadoriaKey++
						this.activeFlashMessage('Código do objeto alterado!', () => {}, 'info')
					})
					.catch(() => {
						this.curadoria = original
						this.curadoriaKey++
					})
			} else {
				this.subcuradorias = param.subCuradorias
			}
		},
		selectSubCuradoria (param) {
			this.subCuradoriaId = param
			this.eixos = param.subCuradorias
			this.eixo = undefined
		},
		selectPedProducao (param) {
			this.form.pedProducao = param
		},
		selectNomesCuradores (param) {
			this.form.curador = param
		},
		selectEixo (param) {
			this.eixo = param
		},
		selectTagsPlus (tag, objRef) {
			this.tagTemp = tag
			this.tagTempText[tag.identificador] = tag.nome
			for (let index = 0; index < objRef.array.length; index++) {
				objRef.array.pop()
			}
		},
		selectAutores (param) {
			this.notPushRepeatItem({ arrayRef: this.form.autores, value: param, prop: 'id' })
		},
		selectPreRequisito (param) {
			this.form.preRequisito = param
		},
		limparTags () {
			this.cursosRecorrentes = []
			this.disciplinasRecorrentes = []
			this.tagsGerais = []
		},
		async onChangeTagPlus (e, objRef, identificadorTag) {
			if (e.target.value.length < 2) {
				this.tagTemp = ''
			}

			if (e.target.value.length > 2) {
				const retorno = await tags.findByNome(e.target.value, identificadorTag)
				if (retorno.data.length) {
					this.notPushRepeatItem({ arrayRef: objRef.array, value: retorno.data, prop: 'id' })
				} else {
					this.limparTags()
				}
			} else {
				this.limparTags()
			}
		},
		async onChangeTitulo (param) {
			if (param.length > 2) {
				this.objetos = []
				this.isLoading = true
				await objetos.findByTitulo(param)
					.then(res => {
						this.objetos = res.data
						this.isLoading = false
					})
					.catch(err => {
						console.log(err)
					})
			}
		},
		notPushRepeatItem (param) {
			const add = param.prop ? !!param.arrayRef.find(item => item[param.prop] === param.value[param.prop]) : !!param.arrayRef.find(item => item === param.value)
			if (!add) param.arrayRef.push(param.value)
		},
		formataUrl () {
			if (this.form.urlObjeto) {
				const includeHttp = this.form.urlObjeto.includes('http')
				// const includeWww = this.form.urlObjeto.includes('www.')
				// const www = includeWww ? '' : 'www.'
				if (includeHttp) {
					if (this.form.urlObjeto) {
						this.form.urlObjeto =
							this.form.urlObjeto
								.replace(/https:\/\/|http:\/\//, this.https ? 'https://' : 'http://')
					}
				} else {
					this.form.urlObjeto = `${this.https ? 'https://' : 'http://'}${this.form.urlObjeto}`
				}
			}
		},
		changeHttpStatus (param) {
			this.https = param.value
			this.formataUrl()
		},
		criaTag (nome, identificador, objRef) {
			const include = objRef.array.some(item => item.nome.toLowerCase() === nome.toLowerCase())
			if (!include) objRef.array.push({ id: '', nome, identificador })
		},
		populaArvoreCuradorias () {
			const subs = []
			this.curadorias.forEach(cur => subs.push(...cur.subCuradorias))
			this.subCuradoria = subs.find(sc => sc.id === this.usuario.curadoriaId)

			if (this.subCuradoria) {
				this.subcuradorias = this.curadorias.find(cur => cur.id === this.subCuradoria.curadoriaId).subCuradorias
				this.curadoria = this.curadorias.find(cur => cur.id === this.subCuradoria.curadoriaId)
				this.eixos = this.subCuradoria.subCuradorias
			} else {
				this.curadoria = this.curadorias.find(cur => cur.id === this.usuario.curadoriaId)
				this.subcuradorias = this.curadorias.find(cur => cur.id === this.usuario.curadoriaId).subCuradorias
			}
		},
		addByEnter (el) {
			this.$refs[el].focus()
			this.$refs[el].click()
		},
		ocultaSugestaoTag (e, param) {
			setTimeout(() => {
				param.ref = []
			}, 200)
		},
		async questionReport () {
			const reportRequest = await questoes.processReport({ tema: this.$route.params.id })
			window.open(reportRequest.data.arquivo)
		},
		manageCurationQuestionsTypes (id) {
			if (this.curadoria.id) {
				if (this.callManageQuestions) {
					this.loadObjectTypesCuradoria(id)
				} else this.callManageQuestions = true
			} else {
				this.loadObjectTypesCuradoria(id)
			}
		},
		mangeObjectCode () {
			if (this.form.codigo) {
				this.form.code = getCode({
					curadoriaCodigo: this.curadoria.codigo,
					tipoCodigo: this.tipo.codigo,
					dtInsert: this.form.datas.formatadas.criacao,
					codigo: this.form.codigo
				}, true)
			}
		},
		async curadoresNomes () {
			await axios.get('/curadoresNomes')
				.then(res => {
					const array = [...res.data]
					const resul = []
					for (const value of array) {
						resul.push(value.nome + ' <' + value.email + '>')
					}
					this.nomesCuradores = [...resul]
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
		},
		async producoesPeriodo () {
			await axios.get('/periodoProducao')
				.then(res => {
					const arrayPed = [...res.data]
					const resulPed = []
					for (const value of arrayPed) {
						resulPed.push(value.periodoName)
					}
					this.pedProducoes = [...resulPed]
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
		}
	}
}
</script>

<style>

.tab-close{
  float:right;
}
.tab-close:hover{
  transform: rotate(7deg);
}

.tinytabs .tabs {
	margin-left: 15px;
	display: flex;
	flex-flow: row wrap;
}
.tinytabs .tabs .tab .close {
	padding-left: 5px;
}
.tinytabs .tabs .tab {
	margin: 0 3px 0 0;
	background: #e1e1e1;
	display: block;
	padding: 6px 15px;
	text-decoration: none;
	color: #666;
	font-weight: bold;
	border-radius: 3px 3px 0 0;
}
.tinytabs .section {
	background: #f1f1f1;
	overflow: hidden;
	padding: 15px;
	clear: both;
	border-radius: 3px;
	background-color: lightblue;
	margin-bottom: 5px;
}
.tinytabs .tab.sel {
	background: #f1f1f1;
	color: #333;
	text-shadow: none;
	background-color: lightblue;
}
</style>

<style lang="scss" scoped>
	#container-datas-obj {
		display: flex;
		justify-content: flex-start;
		gap: 15px;
		border-radius: 4px;
		margin-bottom: 15px;
		font-size: $font-size;
		color: $font-color;
		div {
			label {
				font-weight: 600;
			}
		}
	}

	#container-id-codigo-obj {
		display: flex;
		gap: 10px;
		margin-bottom: 5px;
		> div {
			background-color: $inputs-color;
			border-radius: 4px;
			display: grid;
			align-content: center;
			align-items: center;
			gap: 5px;
			width: 50%;
			height: 50px;
			.label {
				box-sizing: border-box;
				display: grid;
				align-items: center;
				grid-template-columns: fit-content 1fr;
				min-height: 47px;
				padding: 5px 10px;
				border-radius: 4px;
				color: $success-color;
				width: 100%;
				.code-error {
					font-size: .9em;
					font-weight: bold;
					color: $font-color;
					&::before {
						content: '!';
						display: inline-flex;
						justify-content: center;
						align-items: center;
						width: 26px;
						height: 26px;
						margin-right: 10px;
						border-radius: 50%;
						background-color: #FFBB00;
						color: #FFF;
					}
				}
				.title {
					font-size: .9em;
					width: 80px;
				}
				input {
					width: 500px;
				}
			}
			.copy-id-obj {
				display: flex;
				color: $font-color;
				width: 100%;
			}
		}
	}
	.form-container {
		margin-top: 14px;
		display: grid;
		grid-gap: 14px 10px;
		grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas:
			"form-container-area-1"
			"form-container-area-2"
			"form-container-area-3"
			"form-container-area-4"
			"form-container-area-5"
			"form-container-area-6"
			"form-container-area-7"
			"form-container-area-8"
			"form-container-area-9"
			"form-container-area-10"
			"form-container-area-11"
			"form-container-area-12"
			"form-container-area-13"
			"form-container-area-14"
			"form-container-area-15";
		.item {
			background-color: $inputs-color;
			border-radius: 5px;
			min-height: 50px;
			display: flex;
			align-items: center;
			padding: 0 11px;

			.title {
				margin-right: 5px;
			}
			textarea {
				width: 100%;
				min-height: 80px;
				margin: 20px 0 5px;
				resize: none;
			}
		}

		.tipo {
			grid-area: form-container-area-1;
			grid-column: 1/3;
		}

		.status {
			grid-area: form-container-area-1;
			grid-column: 4/5;
		}

		.productionStatus {
			grid-area: form-container-area-1;
			grid-column: 3/4;
		}

		.curadoria{
			grid-area: form-container-area-2;
			grid-column: 1/3;
		}

		.subcuradoria{
			grid-area: form-container-area-2;
			grid-column: 3/5;
		}

		.eixos {
			grid-area: form-container-area-3;
			grid-column: 1/3;
		}

		.titulo {
			grid-area: form-container-area-3;
			grid-column: 3/5;
			input[type=text] {
				width: 100%;
			}
		}

		.descricao {
			grid-area: form-container-area-4;
			grid-column: 1/5;
		}

		.curador{
			grid-area: form-container-area-5;
			grid-column: 1/3;
		}

		.pedProducao{
			grid-area: form-container-area-5;
			grid-column: 3/5;
		}

		.disciplina{
			grid-area: form-container-area-6;
			grid-column: 1/5;
		}

		.codDisc{
			grid-area: form-container-area-7;
			grid-column: 1/3;
		}

		.ordemTema{
			grid-area: form-container-area-7;
			grid-column: 3/5;
		}

		.curador input, .disciplina input, .codDisc input  {
			width:100% !important;
		}

		.adds-container {
			grid-column: 1/5 !important;
			display: grid;
			column-gap: 5px;
			grid-template-areas:
        "adds-container-area-1"
				"adds-container-area-2";
			grid-template-columns: repeat(1, 1fr 130px);
			.titulo-add {
				height: 50px;
				background-color: $inputs-color;
				grid-area: adds-container-area-1;
				grid-column: 1/4;
				padding: 0px 10px;
				border-radius: 4px;
				.search {
					height: inherit;
				}
			}
			.search {
				display: flex;
				grid-column: 1/2;
				padding: 0px;
				input[type=text] {
					width: 100%;
				}
				.fa-search {
					position: absolute;
					right: 15px;
					top: 10px;
				}
			}
			.list {
				position: relative;
				top: -10px;
				grid-column: 1/4;
				border-radius: 4px;
				z-index: 1;
					ul {
					background: #e8e8e8;
					border-radius: 4px;
					max-height: 200px;
					margin-right: 10px;
					li {
						color: $main-color;
						height: 40px;
						background: #fff;
						padding: 12px;
						border-radius: 4px;
						&:hover {
							background: $main-color;
							color: #fff;
						}
						span{
							position: relative;
							bottom: 4px;
						}
					}
				}
			}
			.btn-add {
				button {
					position: relative;
					top: 11px;
				}
				button:disabled {
					background: #dddddd;
					cursor: default;
				}
			}

			.itens-add {
				height: auto;
				grid-area: adds-container-area-2;
				grid-column: 1/4;
				display: flex;
				flex-wrap: wrap;
				padding: 4px 0px;
				.added-item{
					height: 30px;
					margin: 1px 5px;
					padding: 3px 5px 2px 7px;
					display: flex;
					border: dashed $font-color 1px;
					color: $font-color;
					font-weight: 600;
					span{
						margin-right: 5px;
					}
					button {
						border: none;
						color: $font-color;
						background-color: white;
						cursor: pointer;
						position: relative;
						top: 1px;
					}
				}
			}
		}

		#add-cursos-recorrentes {
			grid-area: form-container-area-8;
		}

		#add-disciplinas-recorrentes {
			grid-area: form-container-area-9;
		}

		#add-tags-gerais {
			grid-area: form-container-area-10;
		}

		#add-autores {
			grid-area: form-container-area-11;
		}

		#questoes-container{
			grid-area: form-container-area-12;
			grid-column: 1/5 !important;
			padding: 5px;
			margin: 5px 0px;
			display: flex;
			gap: 10px;
			flex-direction: column;
			position: relative;

			.titulo {
				font: Condensed Bold 14px/26px Roboto;
				display: block;
				align-items: center;
				height: 32px;

				.aviso {
					margin-left: 15px;
					color: rgb(134, 18, 18);
					font-size: 12px;
				}
			}

			.botoes {
				margin-left: 5px;
				position: absolute;
				top: 0;
				right: 0;

				.visualizar {
					margin-right: 5px;
				}
			}

			.disabled {
				.botoes{
					pointer-events: none;
				}
			}
		}

		#tipo-questao-container {
			padding: 5px;
			margin: 5px 0px;
			display: flex;
			gap: 10px;
			flex-direction: column;
		}

		#pre-requisitos-container {
			grid-column: 1/5 !important;
			padding: 5px;
			grid-area: form-container-area-13;
			display: grid;
			.requisitos-label {
				border-bottom: solid 2px $success-color;
				height: 30px;
				color: $success-color;
				i{
					font-size: 22px;
					position: relative;
					top: 3px;
					margin-right: 5px;
				}
				.area-2 {
					background-color: $success-color;
				}
			}
			.requisitos-input {
				background-color: $inputs-color;
				padding: 0px 10px;
				border-radius: 4px;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				margin: 5px 0px;
				input[type=text] {
					height: 100%;
					width: 100%;
					border: none;
					outline: none;
					background: transparent;
				}
				button{
				border: none;
				width: 40px;
				border-radius: 4px;
				background-color: $success-color;
				cursor: pointer;
					i {
						color: white;
						font-weight: 600;
						position: relative;
						top: 2px;
						left: 0px;
					}
				}
			}

			#pre-requisitos{
				.requisito {
					background-color: white;
					display: flex;
					border: dashed $success-color 1px;
					border-radius: 5px;
					display: grid;
					grid-template-columns: 2.5fr 20fr 0.5fr;
					margin-bottom: 2px;
					color: $success-color;
					.tipo-requisito {
						padding: 5px;
						div {
							background-color: $success-color;
							padding: 0px 10px;
							border-radius: 10px;
							text-align: center;
							font-size: 13px;
							color: #fff;
							height: 20px;
							span{
								position: relative;
								bottom: 2px;
								white-space: nowrap;
							}
						}
					}
					.nome-requisito {
							span{
								position: relative;
								top: 2px;
							}
					}
					.btn-remove-requisito {
						button{
							border: none;
							position: relative;
							top: 4px;
							color: $success-color;
							background-color: #fff;
							cursor: pointer;
							font-size: 16px;
						}
					}
				}
			}
		}

		#link-objeto {
			grid-column: 1/5 !important;
			background-color: $inputs-color;
			grid-area: form-container-area-15;
			padding: 4px 4px;
			border-radius: 4px;
			height: 38px;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			margin: 5px 0px;
			i{
				font-size: 15px;
				position: relative;
				top: 8px;
				margin-right: 5px;
			}
			input[type=text] {
				height: 100%;
				width: 100%;
				border: none;
				outline: none;
				background: transparent;
				&::placeholder{
					font-weight: $font-weight-placeholder-bolder;
					font-size: $font-size-placeholder;
					color: $font-color;
				}
			}

			.abrir_objeto {
				display: block;
				padding: 6px;
				margin: 0 5px 0 10px;
				border-radius: 4px;
				background-color: #3367D6;
				color: #FFF;
				cursor: pointer;
			}
		}

		.button {
			padding: 6px 10px;
			border-radius: 6px;
			background: $main-color;
			color: #fff;
			border: none;
			text-transform: uppercase;
			font-weight: $font-weight-default-bolder;
			font-size: .9em;
			cursor: pointer;
			outline: none;
		}
	}

	#modal-code-change{
		.modal {
			width: 30%;
			min-height: auto;
			.text {
				color: $font-color;
			}
		}
		.botoes {
			display: flex;
			gap: 10px;
			justify-content: center;
		}
	}
</style>

<style lang="scss" scoped>
		.modal-blackscreen {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 2;

			display: flex;
			align-items: center;
			justify-content: center;
			width: 100vw;
			height: 100vh;
			background-color: #0007;

			.modal {
				position: fixed;
				z-index: 1;
				width: 700px;
				min-height: 200px;
				padding: 20px;
				margin: 0 50px auto;
				background-color: #fff;
				color: #000;
				box-shadow: #6667 1px 1px 3px 3px;

				.adicionar {
					display: flex;
					align-items: center;
					margin-bottom: 15px;

					i {
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						background-color: #1a2738;
						font-size: 19px;
						height: 30px;
						width: 30px;
						margin-right: 6px;
					}

					p {
						color: #1a2738;
						font-weight: bold;
						font-size: 17px;
						text-transform: uppercase;
					}
				}

				input {
					width: 100%;
					padding: 10px;
					margin-top: 10px;
					border: 1px solid #CCC;
					border-radius: 5px;

					&::placeholder {
						text-transform: uppercase;
					}
				}

				.botoes {
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;
					width: 100%;
					margin-top: 30px;

					button {
						width: unset;
						padding-left: 20px;
						padding-right: 20px;
						text-transform: uppercase;
						font-family: 'Roboto', sans-serif;
					}
				}
			}
		}
</style>

<style lang="scss" scoped>
.container-loading {
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;

	.loading {
		width: 20px;
		height: 20px;
		margin: 0 auto;
		border-radius: 30px;
		box-sizing: border-box;
		border: solid 10px rgba($main-color, 1);
		border-top-color: #fff;
		animation: spin 1s infinite linear;
	}
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss">
	#swal2-content {
		font-family: $font-family;
		color: $font-color;
	}
	.swal2-actions {
		.swal2-confirm {
			background-color: $success-color;
		}
	}
</style>
